import Icon from '../components/Icon.vue'

Icon.register({
  'chevron-circle-up': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M8 256c0-137 111-248 248-248s248 111 248 248-111 248-248 248-248-111-248-248zM239 142.1l-135.5 135.5c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0l101.6-101.6 101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9l-135.5-135.5c-9.4-9.4-24.6-9.4-34 0z'
      }
    ]
  }
})
